import Icon from '../components/Icon';

const Backpacking = Icon(
  'backpacking',
  <>
    <path
      fillRule="evenodd"
      d="M11.64 5.5a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5m0-4a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M5.03 16.44a2.25 2.25 0 0 1-1.18-4.166 1.8 1.8 0 0 1-.1-.584V6.46a1.76 1.76 0 0 1 1.78-1.71h3a1.75 1.75 0 0 1 1.58 1h3.28a2.77 2.77 0 0 1 2.2 1.1l3.16 4.25a1.85 1.85 0 0 1 .33 1.53 1.87 1.87 0 0 1-1 1.25 2 2 0 0 1-.78.2 1.85 1.85 0 0 1-1.39-.63l-1.42-1.262v.382l2.08 5.18a2 2 0 0 1 .157 1.097l6.103-1.387a.75.75 0 0 1 .34 1.46l-22 5a.75.75 0 0 1-.34-1.46l5.703-1.296a2.1 2.1 0 0 1-.513-.784 2.12 2.12 0 0 1 .06-1.62l2.44-5.32H7.15a2.25 2.25 0 0 1-2.12 3m7.99 3.2.028.043-3.083.7 1.603-3.05zm-2.758-7.7h2.727v-1.37a.75.75 0 0 1 .774-.75h.004a.75.75 0 0 1 .542.19l2.66 2.39a.41.41 0 0 0 .5.14.36.36 0 0 0 .19-.24.38.38 0 0 0-.07-.3l-3.2-4.25a1.27 1.27 0 0 0-1-.5h-3.11v4.48q-.002.105-.017.21m-5.233 1.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m10.16 4.89-1.952-4.89h-2.358l3.36 5.4a.53.53 0 0 0 .71.18.54.54 0 0 0 .24-.69m-7.78 1.09 2.317-5.017.918 1.46L8.52 19.96a.63.63 0 0 1-.8.27.58.58 0 0 1-.31-.34.64.64 0 0 1 0-.47M5.354 6.283a.25.25 0 0 1 .177-.073H8.5a.25.25 0 0 1 .25.25v5.23a.25.25 0 0 1-.22.25h-3a.25.25 0 0 1-.25-.25V6.46a.25.25 0 0 1 .073-.177"
      clipRule="evenodd"
    />
    <path d="M14.124 23.777a.75.75 0 0 0 .636.143l8.41-1.91a.75.75 0 0 0-.34-1.46l-8.41 1.91a.75.75 0 0 0-.296 1.317" />
  </>
);

export default Backpacking;
